var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('h1',{staticClass:"text-center mb-5"},[_vm._v(_vm._s(_vm.mensagem))])])}
var staticRenderFns = []

export { render, staticRenderFns }